export const getLocalItems = (key) => {
  const item = localStorage.getItem(key);
  try {
    return item ? JSON.parse(item) : null;
  } catch (err) {
    console.error(`Error parsing localStorage key "${key}":`, err);
    return null;
  }
};

export const setLocalItems = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalItems = (key) => {
  localStorage.removeItem(key);
};
